export const columns: string[] = [
    "select",
    "itemNumber",
    "openingDate",
    "openingHTLBlockPage",
    "description",
    "ataChap",
    "melRef",
    "expExpDate",
    "expExpFlightHours",
    "expExpFlightNumber",
    "expExpCycles",
    "expAuthorizedSignature",
    "referenceDocument",
    "exeDate",
    "exeFlightHours",
    "exeFlightNumber",
    "exeCycles",
    "exeAuthorizedSignature",
    "closureDate",
    "closureHTLBlockPage",
    "closureSignature",
];
